import { ca } from '@cian/analytics';

interface ITrackPinClickParameters {
  isDetailsVisible: boolean;
  isExtended: boolean;
  isResidentialComplex: boolean;
  isResidentialComplexesListing: boolean;
  zoom: number;
}

export function trackPinClick({
  isDetailsVisible,
  isExtended,
  isResidentialComplex,
  isResidentialComplexesListing,
  zoom,
}: ITrackPinClickParameters) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_pin',
    category: 'Map',
    label: `${
      isExtended
        ? 'white'
        : (isResidentialComplexesListing || isDetailsVisible) && isResidentialComplex
        ? 'green'
        : 'blue'
    }/${zoom}`,
  });
}
